import * as React from "react";

const Close: React.FC = () => {
    return <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="3.-Style" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1.Iconography" transform="translate(-266.000000, -417.000000)" fill="currentColor">
            <g transform="translate(79.000000, 230.000000)">
                <g transform="translate(187.000000, 187.000000)" id="UI-Icon/close">
                    <polygon points="17.64 15.48 15.12 18 9 11.52 2.52 18 0 15.48 6.48 9 0.18 2.52 2.7 0 9 6.48 15.48 0 18 2.52 11.52 9"></polygon>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(Close);
